import DocumentComponent from './DocumentComponent';

export default DocumentComponent;
